<template>
  <div class="between_item between_left">
    <card title="实时预警">
      <div class="search_box fb">
        <div class="icon"><img class="Img" src="@/assets/hs/icon_搜索.png" alt="" /></div>
        <div class="input" id="searchInput">
          <el-input v-model="input" placeholder="请输入内容"></el-input>
        </div>
        <p class="btn_search">搜索</p>
      </div>
      <div class="card_table" id="cardTable2">
        <!-- <dv-scroll-board :config="tableConfig" @click="clickWarmList" /> -->
        <el-table
          :data="curStationWarns"
          @row-click="clickWarmList"
          highlight-current-row
          height="300"
          ref="tableRef"
        >
          <el-table-column prop="ord" label="设备名称" align="center" width="130">
            <template slot-scope="scope">
              {{ scope.row.ord || '1#机组' }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="故障名称" align="center"> </el-table-column>
          <el-table-column prop="faultAmount" label="时间" align="center" width="150">
            <template slot-scope="scope">
              {{ scope.row.createTime.substring(5) || '--' }}
            </template>
          </el-table-column>
          <!-- <div class="empty" slot="empty"> -->
          <!-- <img
              class="Img"
              src="data:image/svg+xml;base64,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"
              alt=""
            /> -->
          <!-- <p>暂无实时故障</p>
          </div> -->
        </el-table>
      </div>
    </card>
    <card title="历史故障" styles="margin-top:10px">
      <div class="card_table card_table2" id="cardTable2">
        <!-- <dv-scroll-board :config="tableConfig" @click="clickWarmList" /> -->
        <el-table
          :data="curListData"
          @row-click="clickWarmList"
          highlight-current-row
          height="280"
          ref="tableRef"
        >
          <el-table-column prop="ord" label="设备名称" align="center" width="130">
            <template slot-scope="scope">
              {{ scope.row.ord || '1#机组' }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="故障名称" align="center"> </el-table-column>
          <el-table-column prop="detectability" label="检测难度" align="center" width="90">
            <template slot-scope="scope">
              {{ statusMap[scope.row.detectability] || '未知' }}
            </template>
          </el-table-column>
          <el-table-column prop="faultAmount" label="次数" align="center" width="60">
            <template slot-scope="scope">
              {{ scope.row.faultAmount || 0 }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import * as Api from '@/api';
let timer;
const mockColor = [-1, 1, 2, 3, 2, 3, 1, -1, 2, 3, -1, 1, 3, 2, -1, 2, 1, 3];

export default {
  components: {
    Card,
  },
  data() {
    return {
      input: '',
      tableConfig: {
        header: ['设备名称', '故障原因', '时间', '复杂度'],
        rowNum: 20,
        waitTime: 60000,
        data: [],
        headerBGC: 'rgba(3,74,144,0.3)',
        columnWidth: [150, 150, 150, 150],
        align: ['center', 'center', 'center', 'center'],
        oddRowBGC: 'rgba(14,36,60,0.4)',
        evenRowBGC: 'rgba(14,36,60,0.8)',
      },
      curStationWarns: [],
      curListData: [],
      listQuery: {
        // name: '轴承温度',
        current: 1,
        size: 20,
        display: 1,
        stationId: '17230100205',
      },
      statusMap: {
        '1.0': '容易',
        '2.0': '中等',
        '3.0': '困难',
      },
      curFaultId: '',
      curWarnRowIndex: null,
      curRowData: null,
      isFresh: null,
    };
  },
  mounted() {
    // this.renderTable();
    // this.dealMockData();
    this.curWarnRowIndex = this.$Storage.get('warnRowIndex');
    this.$bus.$on('isFresh', (data) => {
      if (data) {
        this.clickWarmList(this.curRowData);
      }
    });

    console.log(this.curWarnRowIndex);
    this.getFaultList();
    this.$nextTick(() => {
      console.log('this.$refs.tableRef :>> ', this.$refs.tableRef.$el);
    });
  },
  methods: {
    getFaultList() {
      Api.getStationWarns().then((res) => {
        console.log('warns :>> ', res);
        if (res.success) {
          this.curStationWarns = res.data;
          if (this.curWarnRowIndex > -1) {
            console.log('111', this.curStationWarns[this.curWarnRowIndex]);
            // 自动触发点击
            this.clickWarmList(this.curStationWarns[this.curWarnRowIndex]);
          }
        }
      });

      Api.getFaultList(this.listQuery).then((res) => {
        const { data, code } = res;
        if (code == 200) {
          this.curListData = data.records;
          // this.curListData.unshift({
          //   ord: '1#机组',
          //   name: '轴承温度升高',
          //   detectability: '1.0',
          //   faultAmount: '3',
          // });
        }
      });
      // const { records: listData } = this.$Mock.queryFaultListOrd;
      // this.curListData = listData;
    },
    dealMockData() {
      const { records: listData } = this.$Mock.queryFaultListOrd;
      const statusMap = {
        1: '容易',
        2: '中等',
        3: '困难',
      };
      const curList = [];
      listData.forEach((item, index) => {
        const { ord, name, createTime, status } = item;
        curList.push([ord, name, createTime, statusMap[status]]);
      });
      this.tableConfig.data = curList;
    },
    renderTable() {
      const tableData = [];
      for (let i = 0; i < 50; i++) {
        tableData.push([
          `设备${i}`,
          `设备${i}故障`,
          `2022-08-12`,
          `<span class="type1">故障</span>`,
        ]);
      }
      this.tableConfig['data'] = tableData;
    },
    clickWarmList(row) {
      this.curRowData = row;
      const { emCode, fdpId, faultId, name, ord, fdpDeviceName, status, modelDeviceCode } = row;
      const params = {
        type: 2,
        faultId: fdpId || faultId,
        name: name,
        emCode: emCode,
        fdpOrd: ord,
        fdpDeviceName: fdpDeviceName,
      };

      // 假数据，真实数据用上面的入参
      // const params = {
      //   type: 2,
      //   faultId: '17230100202|1#机组|6a784702762c4060a9e4eed63f3a3afe',
      //   name: '蝶阀油压不足',
      //   emCode: null,
      //   fdpOrd: '1#机组',
      //   fdpDeviceName: '蝶阀',
      // };
      this.$bus.$emit('curTable', 1); //关闭右侧排查详情窗口
      Api.getRealTimeHisDataNew(params)
        .then((res) => {
          if (res.code == 200) {
            // this.$Model.i3dHighLight(['SLJ001'], 'T2', '1', '-1');
            if (res.data.id) {
              console.log('res.data.id :>> ', res.data.id);
              this.$bus.$emit('checkTaskId', res.data.id);
              this.$bus.$emit('curFaultInfo', params);
            }
          }
        })
        .catch((err) => {
          this.$bus.$emit('checkTaskId', '-1');
        });
      // this.$Model.i3dInit();
      this.clearHighLight(); //这里取消用init方法
      this.$bus.$emit('curRedDeviceCode', modelDeviceCode); //当前标红的设备id

      setTimeout(() => {
        if (modelDeviceCode) {
          // this.$Model.i3dHighLight([modelDeviceCode], 'T2', '1', '-1');
          this.$Model.i3dHighLight([modelDeviceCode], 'T2', '4', '-1'); //第三个参数为4代表高亮当前标红的设备，并把标牌上移
        }

        // 假数据
        // this.$Model.i3dHighLight(
        //   ['SLQ001', 'SLJ010', 'SLJ011', 'SLJ012', 'SLJ013'],
        //   'T2',
        //   '1',
        //   '3'
        // );
      }, 800);
      // setTimeout(() => {
      //   this.$Model.i3dHighLight(['SLJ009'], 'T2', '1', '-1');
      // }, 600);

      this.$bus.$emit('warmFromIndex', true);
    },
    clearHighLight() {
      this.$Model.i3dHighLight([], 'T2', '3', '1'); //第三个参数为3，就是代表清除其他高亮，但是保留发动机壳隐藏
    },
  },
  beforeDestroy() {
    this.$Model.i3dSinkOff();
    this.$bus.$off('warnRowIndex', null);
    this.$Storage.remove('warnRowIndex'); //由于组件还未渲染，所以要存一份在storage里面
  },
};
</script>

<style lang="scss" scoped>
.search_box {
  width: 480px;
  height: 32px;
  align-items: center;
  background: url('@/assets/hs/bg_搜索.png') no-repeat;
  .icon {
    width: 16px;
    height: 16px;
    margin-left: 16px;
  }
  .input {
    width: 370px;
    height: 32px;
  }
  .btn_search {
    width: 72px;
    height: 32px;
    background: url('@/assets/hs/btn_搜索.png') no-repeat;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    padding-left: 10px;
    box-sizing: border-box;
  }
}
.card_table {
  width: 480px;
  height: 300px;
  margin-top: 5px;
  &.card_table2 {
    height: 280px;
  }
}
</style>
